import React, { Component, Fragment } from "react";
import "./ReVAMPDashboard.css";
// import DashboardTable from "./DashboardTable/DashboardTable";
import { CRUDFunction } from "../../../reduxCURD/container";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft.js";
import { printer } from "react-icons-kit/icomoon/printer.js";
import SvgIcon from "react-icons-kit";
import { languageService } from "../../../Language/language.service";
import { curdActions } from "../../../reduxCURD/actions";
import DashboardTable from "./DashboardTable/DashboardTable";
import { Col, Container, Row } from "reactstrap";
import InfoBlock from "./ReVAMPDashboardComponent/InfoBlock";
import InspectionList from "./ReVAMPDashboardComponent/ListItem";
import PieChart from "./ReVAMPDashboardComponent/PieChart";
import dailyDuePending from "images/ReVAMP/dailyDue.png";
import dailyDueCompleted from "images/ReVAMP/dailyDueG.png";
import LocoNonCompliant from "images/ReVAMP/nonCompliant.png";
import LocoOutOfUse from "images/ReVAMP/outOfUse.png";
import LocoCompliant from "images/ReVAMP/compliant.png";
import Locos from "images/ReVAMP/locos.png";
import { androidSync } from "react-icons-kit/ionicons/androidSync";
import moment from "moment";
import { ToastService } from "../../../utils/toastify";
import ConfirmationDialog from "../../../libraries/ConfirmationDialog";
import { getLoggedInUser } from "../../MainPage/UserInfo";
import { versionInfo } from "../../MainPage/VersionInfo";
// import { ToastService } from "../../../utils/toastify.js";

class ReVAMPDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: { summary: {} },
      dataList: [],
      lastSynced: null,
      isSynced: false,
      confirmationDialog: null,
    };
    this.navigation = this.navigation.bind(this);
    this.handleOutOfUseClick = this.handleOutOfUseClick.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.isApp = this.isApp.bind(this);
    this.handleViewHistoryClick = this.handleViewHistoryClick.bind(this);
    this.handleMaintenanceHistoryClick = this.handleMaintenanceHistoryClick.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
  }
  isApp = () => localStorage.getItem("source");
  handleBack() {
    this.setState({ showOutOfUse: false });
  }
  componentDidMount() {
    this.props.getReVAMPDashboardData("revampDashboard");
    console.log("mount");
  }
  componentDidUpdate(prevProps) {
    const { ReVAMPDashboardData, actionType } = this.props;
    if (actionType === "REVAMPDASHBOARDDATA_READ_SUCCESS" && actionType !== prevProps.actionType) {
      const { assetData } = ReVAMPDashboardData;
      let tl = this.flatdata(assetData);
      this.setState({
        dashboardData: ReVAMPDashboardData,
        dataList: [...tl],
        lastSynced: moment(new Date()).format("llll"),
        isSynced: true,
      });

      this.props.getAppMockupsTypes("OutOfUseAsset");
    }
    if (actionType === "REVAMPDASHBOARDDATA_READ_FAILURE" && actionType !== prevProps.actionType) {
      ToastService.Error("Data Synchronization Failed", "");
    }

    if (
      prevProps.diagnosticsActionType !== this.props.diagnosticsActionType &&
      this.props.diagnosticsActionType === "GET_OOU_LOOKUPS_SUCCESS"
    ) {
      //perform action
    }

    if (prevProps.assetTestActionType !== this.props.assetTestActionType && this.props.assetTestActionType === "ASSETTEST_UPDATE_SUCCESS") {
      this.props.getReVAMPDashboardData("revampDashboard");
    }
  }
  flatdata = (assetData) => {
    let data = [];
    if (assetData) {
      Object.entries(assetData).forEach((e) => {
        const [key, val] = e;
        data.push({
          ...val,
          navigate: this.navigation,
          maintenanceHistoryClick: this.handleMaintenanceHistoryClick,
          outOfUseClick: this.handleOutOfUseClick,
          viewHistory: this.handleViewHistoryClick,
        });
      });
    }
    return data;
  };
  handleOutOfUseClick(data) {
    this.openConfirmationDialog(
      "Confirm",
      "Are you sure you want to apply Out of Use credit?",
      () => {
        const user = getLoggedInUser();
        this.props.updateAssetTest({ _id: data.id, userId: user._id }, `applyoou/${data.id}`);
        this.closeConfirmationDialog();
      },
      "Confirm",
      null,
    );
  }
  handleViewHistoryClick(data) {
    this.props.history.push(`/outOfUse/${data.id}`);
  }

  handleMaintenanceHistoryClick(data) {
    this.props.history.push(`/AssetView/${data.id}/history`);
  }

  navigation(object, data) {
    let dict = {
      blueCard: "Blue Card",
      maintenanceRecord: "Maintenance Records",
      nonCompliant: "Non Compliant",
      reviewMaintenance: "Review Maintenance",
      outOfUseHistory: "Out of Use History",
    };
    let report = dict[object.value];
    if (report && ["nonCompliant", "reviewMaintenance"].includes(object.value)) {
      let reportCode = "";

      switch (object.value) {
        case "nonCompliant":
          reportCode = "noncompliantLocomotiveDescription";
          break;
        case "reviewMaintenance":
          reportCode = "nonCompliantBackToService";
          break;
        default:
          reportCode = "";
          break;
      }
      this.props.history && this.props.history.push("/reports", { assetId: data.id, reportCode: reportCode });
    }
    if (report && ["blueCard"].includes(object.value)) {
      this.props.history && this.props.history.push("/bluecard", { assetId: data.id });
    }
  }
  getInspections = (data) => {
    return data
      .reduce((acc, e) => {
        if (e.LastInspec && Object.keys(e.LastInspec).length > 0) {
          acc.push({
            title: e.name,
            inspectionType: e.LastInspec && e.LastInspec.title,
            inspector: e.LastInspec && e.LastInspec.user && e.LastInspec.user.name,
            date: e.LastInspec && e.LastInspec.date,
          });
        }
        return acc;
      }, [])
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };
  openConfirmationDialog(title, message, confirmCallback, action, data) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
          additionalInfo={data}
        />
      ),
    });
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }
  render() {
    const { summary, assetData } = this.state.dashboardData;

    return (
      <Fragment>
        {this.state.confirmationDialog}
        <Row className="lite-dashboard-container">
          <Col md={12} style={{ padding: "0px 30px 0px 30px" }}>
            <div className={"dashboard-title"}>
              <span>Dashboard</span>
              <div style={{ display: "flex", alignItems: "center", color: "white", gap: "5px" }}>
                <div>
                  <small style={{ fontStyle: "italic" }}>
                    Last Synced: <span style={{ fontSize: "large" }}>{this.state.lastSynced}</span>
                  </small>
                </div>
                <div>
                  <SvgIcon
                    onClick={() => {
                      this.setState({ isSynced: false });
                      this.props.getReVAMPDashboardData("revampDashboard");
                    }}
                    className={this.state.isSynced ? "dashboard-refresh-icon" : ""}
                    icon={androidSync}
                    size={24}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md={8} style={{ padding: "0px 15px 0px 30px" }}>
            <Row>
              <Col lg={4}>
                <InfoBlock title="Total Locomotives" value={summary && summary.noOfLocomotives} icon={Locos} />
              </Col>
              <Col lg={4}>
                <InfoBlock
                  title="Daily Inspections Pending"
                  value={summary && summary.locomotivesDueForDailyInspec}
                  icon={dailyDuePending}
                  disabled={versionInfo.isDailyDisabled()}
                />
              </Col>
              <Col lg={4}>
                <InfoBlock
                  title="Daily Inspections Completed"
                  value={summary && summary.locomotiveDailyInspections}
                  icon={dailyDueCompleted}
                  disabled={versionInfo.isDailyDisabled()}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <InfoBlock title="Out Of Use" value={summary && summary.locomotivesOutOfService} icon={LocoOutOfUse} />
              </Col>
              <Col lg={4}>
                <InfoBlock title="Non-Compliant" value={summary && summary.nonCompliantLocomotives} icon={LocoNonCompliant} />
              </Col>
              <Col lg={4}>
                <InfoBlock title="Compliant" value={summary && summary.compliantLocomotives} icon={LocoCompliant} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {this.state.dataList.length > 0 && (
                  <div className="list-container">
                    <div className="list-Item-heading">Locomotives Overview</div>
                    <DashboardTable data={this.state.dataList} />
                  </div>
                )}
              </Col>
            </Row>
          </Col>
          <Col md={4} style={{ padding: "0px 15px 0px 0px" }}>
            <Col md={12}>{this.state.dataList.length > 0 && <InspectionList items={this.getInspections(this.state.dataList)} />}</Col>
            <Col md={12}>
              <div className="list-container">
                <div className="list-Item-heading">Compliance Status</div>
                <PieChart
                  data={{
                    Compliant: summary && summary.compliantLocomotives,
                    "Non-Compliant Locomotives": summary && summary.nonCompliantLocomotives,
                  }}
                />
              </div>
            </Col>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

let variableList = {
  diagnosticsReducer: {
    oouAssetLookups: [],
  },

  assetTestReducer: {
    assetTests: [],
  },
};
const updateAssetTest = curdActions.updateAssetTest;
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    getAppMockupsTypes,
    updateAssetTest,
  },
};

const ReVAMPDashboardContainer = CRUDFunction(
  ReVAMPDashboard,
  "ReVAMPDashboardData",
  actionOptions,
  variableList,
  ["diagnosticsReducer", "assetTestReducer"],
  "dashboard",
);

export default ReVAMPDashboardContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReVAMP_Dashboard/ReVAMPDashboard.jsx